import React from 'react';
import {Box, Stack} from '@mui/material';
import {
  Body,
  Button,
  Icon,
  Label,
  designSystemToken,
} from '@lightricks/react-design-system';
import formatCentsToDollars from '@/utils/formatCentsToDollars';
import translate from '@/utils/translate';
import type {ProposalAnswer} from '@/api/fetchers/proposal';
import styles from '../CreatorSidePanel.module.scss';

type ApplicationTabProps = {
  questions: ProposalAnswer[];
  isNegotiatedTermsVisible?: boolean;
  negotiatedCostInCents?: number | null;
  usageRightsPeriodInMonths?: number | null;
  onViewFullProfile: () => void;
};

function ApplicationTab({
  questions,
  isNegotiatedTermsVisible = false,
  negotiatedCostInCents,
  usageRightsPeriodInMonths,
  onViewFullProfile,
}: ApplicationTabProps) {
  return (
    <>
      <Box className={styles.tabContent}>
        <Stack className={styles.applicationList}>
          {isNegotiatedTermsVisible && (
            <>
              {negotiatedCostInCents != null && (
                <Stack className={styles.applicationItem}>
                  <Label
                    size="sm"
                    color={designSystemToken('semantic.fg.secondary')}
                  >
                    {translate('Price')}
                  </Label>
                  <Body size="md">
                    {formatCentsToDollars(negotiatedCostInCents)}
                  </Body>
                </Stack>
              )}
              {usageRightsPeriodInMonths && (
                <Stack className={styles.applicationItem}>
                  <Label
                    size="sm"
                    color={designSystemToken('semantic.fg.secondary')}
                  >
                    {translate('Usage Rights Period')}
                  </Label>
                  <Body size="md">
                    {translate('month', {count: usageRightsPeriodInMonths})}
                  </Body>
                </Stack>
              )}
            </>
          )}
          {questions.map((item) => (
            <Stack key={item.question} className={styles.applicationItem}>
              <Label
                size="sm"
                color={designSystemToken('semantic.fg.secondary')}
              >
                {item.question}
              </Label>
              <Body size="md">{item.answer}</Body>
            </Stack>
          ))}
        </Stack>
      </Box>

      <Box className={styles.footer}>
        <Button
          className={styles.viewFullProfileButton}
          appearance="neutral"
          mode="tinted"
          size="medium"
          onClick={onViewFullProfile}
          icon={
            <Icon
              size="small"
              appearance="neutral"
              name="Actions-Arrow-Long-Forward"
            />
          }
          iconPosition="end"
        >
          {translate('View full profile')}
        </Button>
      </Box>
    </>
  );
}

export default ApplicationTab;
